import { supabase } from '../lib/supabase'
import type {
  ProcessRunLog,
  ProcessRunLogFilters,
  ProcessRunLogListResult,
  ProcessRunLogRecentStatusCounts,
} from '../types/processRunLogs'

export const processRunLogsService = {
  async list(filters: ProcessRunLogFilters = {}): Promise<ProcessRunLogListResult> {
    const page = Math.max(1, filters.page ?? 1)
    const limit = Math.max(1, Math.min(100, filters.limit ?? 20))
    const from = (page - 1) * limit
    const to = from + limit - 1

    if (Array.isArray(filters.scheduleIds) && filters.scheduleIds.length === 0) {
      return { logs: [], total: 0 }
    }

    let query = supabase
      .from('process_run_logs')
      .select('*', { count: 'exact' })
      .order('started_at', { ascending: false })

    if (filters.status && filters.status !== 'all') {
      query = query.eq('status', filters.status)
    }
    if (filters.startedAtFrom) {
      query = query.gte('started_at', filters.startedAtFrom)
    }
    if (filters.startedAtTo) {
      query = query.lte('started_at', filters.startedAtTo)
    }
    if (filters.scheduleIds?.length) {
      query = query.in('schedule_id', filters.scheduleIds)
    }

    const { data, error, count } = await query.range(from, to)
    if (error) throw error

    return {
      logs: (data ?? []) as ProcessRunLog[],
      total: count ?? 0,
    }
  },

  async getRecentStatusCounts(limit = 100): Promise<ProcessRunLogRecentStatusCounts> {
    const cappedLimit = Math.max(1, Math.min(500, limit))
    const { data, error } = await supabase
      .from('process_run_logs')
      .select('status')
      .order('started_at', { ascending: false })
      .limit(cappedLimit)

    if (error) throw error

    return (data ?? []).reduce<ProcessRunLogRecentStatusCounts>(
      (acc, row) => {
        if (row.status === 'failed') acc.failed += 1
        if (row.status === 'success') acc.success += 1
        return acc
      },
      { failed: 0, success: 0 }
    )
  },
}
